/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const Burger = ({ isOpen, onClick }) => {
	return (
		<button
			onClick={onClick}
			css={(theme) => [
				theme.resetButton,
				theme.typography.getStyle({ theme }),
				css`
					pointer-events: all;
					display: block;
					padding: 0.34em 0;
					margin: -0.4em;
				`,
			]}
		>
			<svg
				viewBox="0 0 16 12"
				width="16"
				height="12"
				css={css`
					display: block;
					width: 1.8em;
					height: ${(1.8 / 16) * 12}em;
					stroke: currentColor;
					stroke-width: 0.5;
				`}
			>
				<AnimatePresence>
					{!isOpen ? (
						<motion.g
							key="bars"
							initial={{ scale: 0 }}
							exit={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{ delay: 1 }}
						>
							<line x1="4" y1="2" x2="12" y2="2" />
							<line x1="4" y1="6" x2="12" y2="6" />
							<line x1="4" y1="10" x2="12" y2="10" />
						</motion.g>
					) : (
						<motion.g key="cross" initial={{ scale: 0 }} exit={{ scale: 0 }} animate={{ scale: 1 }}>
							<line x1="6" y1="4" x2="10" y2="8" />
							<line x1="10" y1="4" x2="6" y2="8" />
						</motion.g>
					)}
				</AnimatePresence>
			</svg>
		</button>
	);
};

export default memo(Burger);
